import zod from 'zod';

export const AlarmCentralEditionFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string(),
  macAddress: zod.string().optional(),
  model: zod
    .enum([
      'AMT4010',
      'AMT2018EEG',
      'AMT1016NET',
      'AMT2110',
      'AMT2118EG',
      'ANM24NET',
      'AMT2018E3G',
      'AMT2018ESMART',
      'ELC3020NET',
      'AMT8000',
      'AMT8000PRO',
      'AMT8000LITE',
      'GPRS1000UN',
      'AMT1000SMART',
      'ACTIVE8ULTRA',
      'ACTIVE20BUS',
      'ACTIVE20ULTRA',
      'ACTIVE20ETHERNET',
      'ACTIVE20GPRS',
      'ACTIVE32DUO',
      'ACTIVE100BUS',
      'ACTIVEFULL32',
      'ACTIVE20',
      'ACTIVE8W',
      'M300',
      'M300FLEX',
      'SMARTALARMM',
      'SMARTALARMME',
      'SMARTALARMMONITORADA',
      'EVO48',
      'EVO192',
      'EVOHD',
      'MG5000',
      'MG5050',
      'ESPECTRA1728',
      'ESPECTRA1738',
      'ESPECTRA1832',
      'ESPECTRA1864',
      'SP4000',
      'SP5500',
      'SP6000',
      'SP7000',
    ])
    .optional(),
  company: zod
    .enum(['INTELBRAS', 'JFL', 'VETTI', 'ALERTAI', 'PARADOX'])
    .optional(),
  password: zod.string().nullish(),
  ip: zod.string().optional(),
  port: zod.string().optional(),
  isVirtual: zod.boolean(),
  account: zod.string().nullish(),
  isPartitionable: zod.boolean().optional(),
  webhookId: zod.number().nullish(),
});
